import React, { useCallback } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ContactsIcon from '@material-ui/icons/Contacts';
import { tabIconViewBox, useTabStyles } from '../../utils/tabStyles';

const SUB_PATH_REGEX = /(\/adressen-import)\/?.*/;

const AbacusInterfaceTabs: React.FC<RouteComponentProps> = ({ history, location }) => {
  const classes = useTabStyles();

  const navigate = useCallback(
    (e: React.ChangeEvent<any>, path: string) => history.push(path),
    [history],
  );
  const tabValue = SUB_PATH_REGEX.exec(location.pathname)![1];

  return (
    <Tabs
      value={tabValue}
      onChange={navigate}
      variant="scrollable"
      scrollButtons="auto"
      classes={{ scrollButtons: classes.scrollButtons }}
    >
      <Tab
        className={classes.tabRoot}
        label={
          <>
            <ContactsIcon classes={{ root: classes.rootIcon }} viewBox={tabIconViewBox} />
            Adressen
          </>
        }
        value={`/adressen-import`}
      />
    </Tabs>
  );
};

export default AbacusInterfaceTabs;
